import { useCallback } from "react";
import {
  Container,
  Dropdown,
  DropdownButton,
  Nav,
  Navbar,
  Image,
} from "react-bootstrap";
import { BsClockHistory, BsPerson, BsDoorOpen } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import useRouteStatus from "../../../hooks/route-status";
import Logo from "../../../images/logo-white.svg";
import { hasRole } from "../../../utils/roles";
import BookingSearch from "../../booking-search/BookingSearch";
import loginPageSlice from "../../login-page/store/slice";
import RoleBadge from "../../role-badge/RoleBadge";
import { RoleCode } from "../../users/store/slice";
import styles from "./header.module.scss";

const Header = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { isPublicRoute } = useRouteStatus();

  const isLoggedIn = useSelector((state) => state.loginPage.isLoggedIn);
  const profile = useSelector((state) => state.loginPage.profile);

  const logout = useCallback(
    () => dispatch(loginPageSlice.actions.logout()),
    [dispatch]
  );
  const revokeToken = useCallback(
    () => dispatch(loginPageSlice.actions.revokeToken()),
    [dispatch]
  );

  if (isPublicRoute || !isLoggedIn || !profile) return null;

  return (
    <header className="shadow-sm">
      <Navbar bg="primary" variant="dark" expand="xl">
        <Container fluid>
          <Navbar.Brand as={Link} to="/bookings">
            <Image alt="logo" src={Logo} className={styles.logo} />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link
                as={Link}
                to="/bookings"
                active={location.pathname === "/bookings"}
              >
                Bookings
              </Nav.Link>
              {hasRole(profile, RoleCode.Internal) && (
                <>
                  <Nav.Link
                    as={Link}
                    to="/companies"
                    active={location.pathname === "/companies"}
                  >
                    Companies
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/users"
                    active={location.pathname === "/users"}
                  >
                    Users
                  </Nav.Link>
                </>
              )}
              <Nav.Link
                as={Link}
                to="/docs"
                target="_blank"
                active={location.pathname === "/docs"}
              >
                API
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
          <Navbar.Collapse className={styles.headerInfo}>
            <BookingSearch />

            <DropdownButton
              id="user-dropdown"
              className={styles.userActions}
              align={{ xs: "start" }}
              title={
                <>
                  {profile.roles.map(({ name }, index) => (
                    <RoleBadge
                      key={index}
                      name={name}
                      className={styles.roleBadge}
                    />
                  ))}
                  <span>{profile.name}</span>
                </>
              }
            >
              <Dropdown.Item as={Link} to="/profile">
                <BsPerson /> Profile
              </Dropdown.Item>
              <Dropdown.Item as={Link} to="/activity">
                <BsClockHistory /> Activity
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item
                onClick={() => {
                  revokeToken();
                  logout();
                }}
              >
                <BsDoorOpen /> Logout
              </Dropdown.Item>
            </DropdownButton>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
